export default "__VITE_ASSET__92f2f270__"